import { psAxios } from '@patsnap/common-ps-http';
import { getFingerprint } from '../../utils/fingerprint';

const CLIENT_NAME = import.meta.env.VITE_PASSPORT_CLIENT_NAME;

let _header = {};

/**
 * 设置项目请求的 header
 * @param headers
 */
export function setProjectRequestHeaders(headers: Record<string, unknown>): void {
    _header = headers;
}

/**
 * 项目请求拦截器
 * @description 添加 X-PatSnap-From header 和开发环境的模拟用户身份
 */
export const projectRequestInterceptor = async(config: any) => {
    if (config.headers) {
        config.headers['X-PatSnap-From'] = `w-${CLIENT_NAME}`;
    }
    // 开发环境专用：模拟用户身份，生产环境会被编译器移除
    if (import.meta.env.DEV) {
        if (config.baseURL === 'http://127.0.0.1:8080/telecom' || config.baseURL === 'http://127.0.0.1:8000/v2/novelty') {
            config.headers = config.headers || {};
            const token = (config.headers['Authorization'] as string)?.replace(/^Bearer\s+/i, '');
            if (token) {
                try {
                    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
                    if (payload.sub) config.headers['X-User-Id'] = payload.sub;
                    if (Array.isArray(payload.authorities)) config.headers['X-User-Roles'] = payload.authorities.join(',');
                } catch { /* token 解析失败时不设置 header */ }
            }
        }
    }
    config.headers = {
        ...config.headers,
        ..._header,
    };

    return config;
};

/**
 * 注入项目请求拦截器
 */
export function injectProjectRequestInterceptor() {
    if (!psAxios.psInterceptors.projectRequestInterceptor) {
        psAxios.psInterceptors.projectRequestInterceptor = psAxios.interceptors.request.use(
            projectRequestInterceptor,
            undefined,
        );
    }
}

/**
 * 移除项目请求拦截器
 */
export function ejectProjectRequestInterceptor() {
    if (psAxios.psInterceptors.projectRequestInterceptor) {
        psAxios.interceptors.request.eject(psAxios.psInterceptors.projectRequestInterceptor);
        delete psAxios.psInterceptors.projectRequestInterceptor;
    }
}
